function initialize() {
    $(function () {
        $('#utility .user').remove();
        $('input[type="password"]').bind('contextmenu paste', function () { return false; });
    });
}

window.initialize = initialize;
